import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Redux Saga
import {
  GET_DELIVERY_MEN_SUCCESS,
  GET_DELIVERY_MEN_FAIL,
  GET_DELIVERY_MAN_SUCCESS,
  GET_DELIVERY_MAN_FAIL,
  CREATE_DELIVERY_MAN_SUCCESS,
  CREATE_DELIVERY_MAN_FAIL,
  UPDATE_DELIVERY_MAN_SUCCESS,
  UPDATE_DELIVERY_MAN_FAIL,
  DELETE_DELIVERY_MAN_SUCCESS,
  DELETE_DELIVERY_MAN_FAIL,
} from "./actionTypes"

// Delivery men actions
import {
  getDeliveryMen as getDeliveryMenAction,
  getDeliveryMan as getDeliveryManAction,
} from "./actions"

// API functions
import {
  getDeliveryMen,
  getDeliveryManById,
  createDeliveryMan,
  updateDeliveryMan,
  deleteDeliveryMan,
} from "../../helpers/backend_helper"

// Toast for notifications
import { toast } from "react-toastify"

// Get all delivery men
function* fetchDeliveryMen({ payload: { history } }) {
  try {
    const response = yield call(getDeliveryMen)
    yield put({ type: GET_DELIVERY_MEN_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_DELIVERY_MEN_FAIL, payload: error })
    toast.error("Failed to load delivery men")
  }
}

// Get single delivery man
function* fetchDeliveryMan({ payload: { deliveryManId, history } }) {
  try {
    const response = yield call(getDeliveryManById, deliveryManId)
    yield put({ type: GET_DELIVERY_MAN_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_DELIVERY_MAN_FAIL, payload: error })
    toast.error("Failed to load delivery man details")
  }
}

// Create delivery man
function* onCreateDeliveryMan({ payload: { deliveryMan, history } }) {
  try {
    const response = yield call(createDeliveryMan, deliveryMan)
    yield put({ type: CREATE_DELIVERY_MAN_SUCCESS, payload: response })
    toast.success("Delivery man created successfully!")
    // Refresh the delivery men list
    yield put(getDeliveryMenAction(history))
  } catch (error) {
    yield put({ type: CREATE_DELIVERY_MAN_FAIL, payload: error })
    toast.error("Failed to create delivery man")
  }
}

// Update delivery man
function* onUpdateDeliveryMan({ payload: { deliveryManId, deliveryMan, history } }) {
  try {
    yield call(updateDeliveryMan, deliveryManId, deliveryMan)
    // Fetch the updated delivery man by ID
    const updatedDeliveryMan = yield call(getDeliveryManById, deliveryManId)
    yield put({ type: UPDATE_DELIVERY_MAN_SUCCESS, payload: updatedDeliveryMan })
    toast.success("Delivery man updated successfully!")
  } catch (error) {
    yield put({ type: UPDATE_DELIVERY_MAN_FAIL, payload: error })
    toast.error("Failed to update delivery man")
  }
}

// Delete delivery man
function* onDeleteDeliveryMan({ payload: { deliveryManId, history } }) {
  try {
    const response = yield call(deleteDeliveryMan, deliveryManId)
    yield put({ type: DELETE_DELIVERY_MAN_SUCCESS, payload: response })
    toast.success("Delivery man deleted successfully!")
    // Refresh the delivery men list
    yield put(getDeliveryMenAction(history))
  } catch (error) {
    yield put({ type: DELETE_DELIVERY_MAN_FAIL, payload: error })
    toast.error("Failed to delete delivery man")
  }
}

// Watchers
function* getDeliveryMenSaga() {
  yield takeEvery("GET_DELIVERY_MEN", fetchDeliveryMen)
}

function* getDeliveryManSaga() {
  yield takeEvery("GET_DELIVERY_MAN", fetchDeliveryMan)
}

function* createDeliveryManSaga() {
  yield takeEvery("CREATE_DELIVERY_MAN", onCreateDeliveryMan)
}

function* updateDeliveryManSaga() {
  yield takeEvery("UPDATE_DELIVERY_MAN", onUpdateDeliveryMan)
}

function* deleteDeliveryManSaga() {
  yield takeEvery("DELETE_DELIVERY_MAN", onDeleteDeliveryMan)
}

// Export all sagas
function* deliveryMenSaga() {
  yield all([
    fork(getDeliveryMenSaga),
    fork(getDeliveryManSaga),
    fork(createDeliveryManSaga),
    fork(updateDeliveryManSaga),
    fork(deleteDeliveryManSaga),
  ])
}

export default deliveryMenSaga
